export default () => {
  let headerLoginTrigger = $('.headerLogin__trigger');
  let headerLogOutTrigger = $('.headerLogout__trigger');

  headerLoginTrigger.on('click', function (evt) {
    evt.preventDefault();

    if ($(this).hasClass('is-active')) {
      headerLoginTrigger.html('Login');
    } else {
      headerLoginTrigger.html('Close');
    }

    headerLoginTrigger.toggleClass('is-active');
    $('.headerLogin').toggleClass('is-active');
  });

  headerLogOutTrigger.on('click', function (evt) {
    evt.preventDefault();

    if ($(this).hasClass('is-active')) {
      headerLogOutTrigger.html('Logout');
    } else {
      headerLogOutTrigger.html('Cancel');
    }

    headerLogOutTrigger.toggleClass('is-active');
    $('.headerLogout').toggleClass('is-active');
  });
}



// WEBPACK FOOTER //
// ./themes/app/assets/js/modules/logIn.js